import React, { Component } from "react";
import Select from "react-select";
import DataTable from 'react-data-table-component';
import { formatoSeparadorMilesValue } from "../utils/FormatoInput";
import { pintarFilaSeleccionada } from "../../generico/utils/Tabla";

const tipoPresentacion = {
  select: "SELECT",
  tabla: "TABLA"
};

const paginationOptions = {
  rangeSeparatorText: "de",
  noRowsPerPage:true
};
export default class TarjetaCreditoSocio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: this.props.itemSelected,
      opcion: [],
      listaTarjeta: [],
    };
  }

  componentDidMount() {
    this.getListaTarjeta();
  }

  getListaTarjeta() {
    var respuesta = [];
      respuesta.push({
        id: 1,
        tarjeta: "5418 6321 1049 7364",
        tipo: "MASTER",
        saldo: formatoSeparadorMilesValue(3132875) + " GS"
      },{
        id: 2,
        tarjeta: "6020 4900 0387 1981",
        tipo: "PANAL",
        saldo: formatoSeparadorMilesValue(-421214) + " GS"
      },{
        id: 3,
        tarjeta: "6020 4900 0358 4758",
        tipo: "PANAL",
        saldo: formatoSeparadorMilesValue(9892739) + " GS"
      });
    this.setState({ listaTarjeta: respuesta });
    return this.state.listaTarjeta;
  }

  getColumn() {
    return [
      {
        name: "Tarjeta",
        selector: row => row.tarjeta,
        width: "180px",
      },
      {
        name: "Tipo",
        selector: row => row.tipo
      },
      {
        name: "Saldo",
        selector: row => row.saldo,
        width: "150px",
      },
      {
        cell: (row) => (
          <input
            ref={() => this.grupoSel}
            id={"radio_" + row.id}
            type="radio"
            key={row.id}
            type="radio"
            name="rowRadio"
            value={row.id}
            onClick={this.selGrupoEvt}
          ></input>
        ),
        width: "50px",
      },
    ];
  }

  seleccionarFila(row){
    //pintarFilaSeleccionada("row-" + row.id)
    //// admin de radio button
    var radio = document.getElementById("radio_" + row.id)
    radio.checked = true
    //radio.click(this.selGrupoEvt);
  }

  handleChangeSelector = (selectedOption) => {
    
    if (selectedOption == null)
      this.props.selectorValue(undefined);
    else
      this.props.selectorValue(selectedOption.value, selectedOption);
  };

  obtenerTarjeta() {
    switch (this.props.presentacion) {
      case tipoPresentacion.select:
       
        return (
          <div className="form-group">
            <label className="input-label-bold">{this.props.titulo} *</label>
            <div className="is-invalid" id="prueba">
            <Select  id="tipo" name="tipo"
              defaultValue={this.props.itemSelected}
              onChange={this.handleChangeSelector}
              placeholder="-- seleccione --"
              options={this.props.tarjetas}
              isClearable
              noOptionsMessage={() => 'SIN DATOS'}
            />  
            </div>           
          </div>
        );
      case tipoPresentacion.tabla:
        return(
          <div className="row justify-content-md-center">
            <div className="col-md-12">
              <div className="row"> 
                <div className="table-responsive">
                <DataTable
                  noHeader={true}
                  pagination={true}
                  columns={this.getColumn()}
                  data={this.state.listaTarjeta}
                  dense={true}
                  pagination={true}
                  paginationComponentOptions={paginationOptions}
                  noDataComponent="no hay registros para mostrar"
                  responsive={true}
                  striped={true}
                  pointerOnHover
                  onRowClicked={(e)=>this.seleccionarFila(e)}/>                       
                </div>                          
              </div>   
            </div>                       
          </div> 
        )
        break;
    }   
  }
  

  render() {
    const { selectedOption } = this.state;
    return (
      <div>
        <div className="form-group">
          {this.obtenerTarjeta()}
        </div>
      </div>
    );
  }
}
